import { PropertyValues, TemplateResult } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { DonutChartWidgetPayload, DonutChartWidgetSliceConfig } from '@nirvana/shared/dtos/types/widgets/common';
import { translateFn } from '../../../../utils/translator.helper';
import { NavigationHelper } from '@nirvana/shared/navigation';
import { GzDonutChartWidgetWebComponent } from '../../../../ui/gzDonutChartWidget';
import { WEB_COMPONENT_GZ_RM_SCANNED_IDENTITIES_WIDGET } from '../../../../webcomponents.constants';
import { ColumnKeys as UsersAppColumnKeys } from '../../../usersApp/types';
import { BaseWebComponentTranslator } from '../../../../framework/BaseWebComponentTranslator';
import { State } from '../../../common/constants';
import { renderIdentityMonitoringDisabled } from '../../identity.monitoring';

/**
 * @summary Type here the description of this component
 * @tag gz-rm-scanned-identities-widget
 */
@customElement(WEB_COMPONENT_GZ_RM_SCANNED_IDENTITIES_WIDGET)
export class GzRmScannedIdentitiesWidgetWebComponent extends GzDonutChartWidgetWebComponent {
  @property({ type: Object, attribute: true })
  payload: DonutChartWidgetPayload & { companyId?: string; identityMonitoringDisabled?: boolean };

  private hoverColor: string;

  constructor() {
    super();
  }

  firstUpdated() {
    super.firstUpdated();
    this.hoverColor = getComputedStyle(document.body).getPropertyValue('--blue-layout-400-primary');
    this.style.setProperty('--top-padding', '0');
  }

  async updated(changedProperties: PropertyValues) {
    await super.updated(changedProperties);
    this.style.setProperty('--hover-color', this.hoverColor);
  }

  willUpdate(properties: PropertyValues) {
    super.willUpdate(properties);

    if (properties.has('payload')) {
      if (this.payload.donutChart?.config) {
        this.payload.donutChart.config.label = translateFn('scanned identities');
        this.payload.donutChart.config.slices = this.payload.donutChart.config.slices.map(slice => ({
          ...slice,
          label: BaseWebComponentTranslator.getInstance().getRiskManagementUserType(parseInt(slice.id, 10)),
        }));
      }
    }
  }

  public handleTitleClick(): void {
    this.viewAll();
  }

  protected viewAll(): void {
    NavigationHelper.navigateToRiskManagement({
      company: { id: this.payload.companyId ?? '' },
      filters: [
        {
          [UsersAppColumnKeys.STATE]: { in: [State.ACTIVE] },
        },
        {
          [UsersAppColumnKeys.RISK_SCORE]: { range: { min: 1, max: 100 } },
        },
      ],
      section: 'identities',
      newTab: true,
    });
  }

  protected renderLegendContainer(): TemplateResult | undefined {
    if (this.payload?.identityMonitoringDisabled) {
      return renderIdentityMonitoringDisabled();
    }

    return super.renderLegendContainer();
  }

  protected handleChartLegendItemClick(sliceConfig: DonutChartWidgetSliceConfig) {
    NavigationHelper.navigateToRiskManagement({
      company: { id: this.payload.companyId ?? '' },
      section: 'identities',
      filters: [
        {
          [UsersAppColumnKeys.USER_TYPE]: { in: [parseInt(sliceConfig.id, 10)] },
        },
        {
          [UsersAppColumnKeys.STATE]: { in: [State.ACTIVE] },
        },
        {
          [UsersAppColumnKeys.RISK_SCORE]: { range: { min: 1, max: 100 } },
        },
      ],
      newTab: true,
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-rm-scanned-identities-widget': GzRmScannedIdentitiesWidgetWebComponent;
  }
}
